// extracted by mini-css-extract-plugin
export default {"menubar":"doc-menu_menubar__pn4cx","endbuttons":"doc-menu_endbuttons__Ub9L+"};